import { Directive, ElementRef, AfterViewInit, afterNextRender, input, effect } from '@angular/core';

@Directive({
  standalone:false,
  selector: '[appAutoFocus]'
})

export class AutoFocusDirective implements AfterViewInit {
  readonly appAutoFocus = input<boolean>(true);

  constructor(private el: ElementRef<HTMLInputElement>) {
    effect(() => {
      if (this.appAutoFocus()) {
        setTimeout(() => {
          const input = this.el.nativeElement;
          input.focus();
          const length = input.value.length;
          input.setSelectionRange(length, length);
        }, 0);
      }
    });
  }

  ngAfterViewInit() {}
    
}